const h = {
  languageText: 'English',
  title1: 'About Us',
  title2: 'Products',
  title3: 'Contact Us',
  bannerSubTitle: 'Application Globalization Service Provide',
  bannerSubText1: 'Open and Pragmatic',
  bannerSubText2: 'User-oriented',
  bannerSubText3: 'Global Vision',
  desc1:
    'SmallStep Funvalley, established in September 2021, is dedicated to app globalization, mobile advertising, and monetization, providing high-quality products and services to users worldwide. Our product lines cover various regions, including Hong Kong, Macau, Taiwan, Southeast Asia, Europe, and the United States, with a cumulative user base exceeding 10 million.',
  desc2:
    'At SmallStep Funvalley, we remain committed to our original intention, approaching our users with an open and pragmatic mindset. With a keen market awareness and foresight into industry development, we continuously explore and innovate, meticulously refining our products to deliver exceptional products and services to users globally.',
  phrase1: 'Extensive Experience',
  phrase2: 'Creative Young Team',
  phrase3: 'Robust Resources',
  phrase4: 'User-Centric Growth',
  infoTitle1: 'Address',
  infoTitle2: 'Email',
  infoDesc1: 'Room R143, No. 202, Baoxing Street, Nanzhou Road, Haizhu District, Guangzhou, Guangdong Province',
  infoDesc2: 'develpoer@legustudio.com',
  infoDesc3: 'Filing Number: Yue ICP No. 2024311654',
  infoDesc4: 'Guangzhou SmallStep Funvalley Technology Co., Ltd',
  infoDesc5: 'Privacy Policy',
  infoDesc6: 'Terms Of Service',
  home: 'home'
};

export default h;
